"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosVariantUpdateInputSchema = exports.APosVariantCreateInputSchema = exports.APosVariantSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
const product_schema_1 = require("./product.schema");
exports.APosVariantSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    variantId: id_schema_1.EntityIdSchema,
    productId: id_schema_1.EntityIdSchema,
    displayName: zod_1.z.string().min(1).max(200),
    sku: zod_1.z.string().optional(),
    images: zod_1.z.array(zod_1.z.string().url()).optional(),
    thumbnail: zod_1.z.string().url().optional(),
    costPrice: zod_1.z.number().nonnegative(),
    // Inventory — null = inherit from product.trackInventory
    trackInventory: zod_1.z.boolean().nullable().default(null),
    lowStockThreshold: zod_1.z.number().int().nonnegative().optional(),
    // Weighted item fields
    isWeighted: zod_1.z.boolean().default(false),
    weightUnit: zod_1.z.enum(['lb', 'kg', 'oz', 'g']).optional(),
    tareWeight: zod_1.z.number().nonnegative().optional(),
    pluCode: zod_1.z.string().max(10).optional(),
    // Compliance alert override (null = inherit from product.alertConfig)
    alertConfig: product_schema_1.APosAlertConfigSchema.nullable().optional(),
    // Loyalty override (null = inherit from product.loyaltyConfig)
    loyaltyConfig: product_schema_1.APosLoyaltyConfigSchema.nullable().optional(),
    // Review status — set to needs_review after category change; cleared on variant save
    status: zod_1.z.enum(['active', 'pending_delete', 'needs_review', 'inactive']).default('active').optional(),
    // Module 29 (Oil Blending) — synthetic "Blend Refill" placeholder variants.
    // Default false; filtered OUT of admin catalog + storefront / POS lists.
    is_refill_placeholder: zod_1.z.boolean().optional(),
    // AI Inventory Alerts — supplier + replenishment lead time
    defaultSupplierId: zod_1.z.string().optional(),
    leadTimeDays: zod_1.z.number().int().nonnegative().optional(),
    // Clothing — which option values this variant is, e.g. { Color: 'Navy', Size: 'M' }
    options: zod_1.z.record(zod_1.z.string().max(20), zod_1.z.string().max(40)).optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosVariantCreateInputSchema = zod_1.z.object({
    productId: id_schema_1.EntityIdSchema,
    displayName: zod_1.z.string().min(1).max(200),
    sku: zod_1.z.string().optional(),
    images: zod_1.z.array(zod_1.z.string().url()).optional(),
    thumbnail: zod_1.z.string().url().optional(),
    costPrice: zod_1.z.number().nonnegative(),
    trackInventory: zod_1.z.boolean().nullable().optional(),
    lowStockThreshold: zod_1.z.number().int().nonnegative().optional(),
    isWeighted: zod_1.z.boolean().optional(),
    weightUnit: zod_1.z.enum(['lb', 'kg', 'oz', 'g']).optional(),
    tareWeight: zod_1.z.number().nonnegative().optional(),
    pluCode: zod_1.z.string().max(10).optional(),
    alertConfig: product_schema_1.APosAlertConfigSchema.nullable().optional(),
    loyaltyConfig: product_schema_1.APosLoyaltyConfigSchema.nullable().optional(),
    // AI Inventory Alerts — supplier + replenishment lead time
    defaultSupplierId: zod_1.z.string().optional(),
    leadTimeDays: zod_1.z.number().int().nonnegative().optional(),
    // Clothing — which option values this variant is, e.g. { Color: 'Navy', Size: 'M' }
    options: zod_1.z.record(zod_1.z.string().max(20), zod_1.z.string().max(40)).optional(),
});
exports.APosVariantUpdateInputSchema = exports.APosVariantCreateInputSchema.partial().extend({});
//# sourceMappingURL=variant.schema.js.map